var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white p-3"},[_c('PageHeaderUI',{attrs:{"back":"","title":"View Wallet Details","breadcrumb":"Billings & Payments > My Transactions"}}),_c('div',[_c('WalletDetails')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }